<template>
	<div id="indexpage"  v-title data-title="产业招商大脑-首页">
		<headerbar msg="chanyednao" :curindex="10"> </headerbar>
		<!-- <div class="indexblackbg"></div> -->
		<!-- <iframe width='100%' height="910" src="http://share.shanhaibi.com/61035f96285bb/" frameborder=0 allowfullscreen=false></iframe> -->
		<div class="index_block" style="margin-top:10px;">
			<div class="centerpage whitebox">
				<div class="block_title oh">
					<h3 class="title fl">产业链图谱</h3>
					<div class="fl" style="display: none;">
						<span class="current">热点推荐</span>
						<span @click="routerTo('industrial-opportunities',{ categoryid: 10560 })"
							class="a-router">大健康</span>
						<span @click="routerTo('industrial-opportunities',{ categoryid: 10561 })"
							class="a-router">信息技术</span>
						<span @click="routerTo('industrial-opportunities',{ categoryid: 10562 })"
							class="a-router">高端制造</span>
						<span @click="routerTo('industrial-opportunities',{ categoryid: 10563 })"
							class="a-router">能源环保材料</span> 
					</div>
					<!-- <span @click="routerTo('industrial-opportunities')" 	class="a-router fr">查看更多>></span> -->
				</div>
				<ul class="hotchain-list">
					<li v-for="(list,index) in hotchainlist" @click="chainrouter('chaindetail',list.chainId)" :key="index">
						<div class="imgbox"><img :src="list.image" v-bind:alt="list.chainName"></div>
							<h5 class="title">{{list.chainName}}</h5> 
					</li>
				</ul>
			</div> 
		</div>
		<div class="index_block">
			<div class="centerpage whitebox">
				<div class="block_title oh">
					<h3 class="title fl">龙头企业招商</h3>
					<span @click="routerTo('leading-enterprises',{  })" class="a-router fr">查看更多>></span>
				</div>
				<ul class="index_leaderc_list"> 
					<li v-for="(list,index) in leadingenlist" @click="enterpriserouter('/enterprises',2,list.stockCode)"  >
						<div class="mibox"> 
							<div class="mi-title oh">
								<span class="title fl">{{list.title}}</span><span v-show="list.status!=''" :class="list.status == '注销'?'companystatus-in fl cancellation':'companystatus-in fl '" >{{list.status}}</span>
							</div>
							<p class="companyinfor ">
								<span><i>注册资本：</i><em>{{list.regCapital}}</em></span>
								<span><i>地区：</i><em>{{list.area}}</em></span>
							</p>
							<p class="companyinfor">
								<span class="fl"><i>所属行业：</i><em>{{list.industry}}</em> </span>
								<span class="fl"><i>成立日期：</i><em>{{list.createTime}}</em> </span>
							</p> 
							<p class="conpanytags" v-if="list.tag!='' ||list.notion!='' ">
									<span v-for="item in list.taglist" class="tagspan">{{item}}</span>
									<span v-for="item in list.notionlist" class="notionspan">{{item}}</span>
							</p>
						</div>
					</li> 
				</ul>
			</div> 
		</div>
		<div class="index_block">
			<div class="centerpage whitebox">
			<div class="block_title oh">
				<h3 class="title fl">创新企业招商</h3>
				<span @click="routerTo('innovative-enterprises',{})" class="a-router fr">查看更多>></span>
			</div>
			<ul class="index_leaderc_list"> 
				<li v-for="(list,index) in innovativeenlist" @click="enterpriserouter('/enterprises',3,list.stockCode)"  >
					<div class="mibox"> 
						<div class="mi-title oh">
							<span class="title fl">{{list.title}}</span><span v-show="list.status!=''" :class="list.statustype == 1?'companystatus-in fl':'companystatus-in fl cancellation'" >{{list.status}}</span>
						</div>
						<p class="companyinfor ">
							<span><i>注册资本：</i><em>{{list.regCapital}}</em></span>
							<span><i>地区：</i><em>{{list.area}}</em></span>
						</p>
						<p class="companyinfor">
							<span class="fl"><i>所属行业：</i><em>{{list.industry}}</em> </span>
							<span class="fl"><i>成立日期：</i><em>{{list.createTime}}</em> </span>
						</p> 
						<p class="conpanytags" v-if="list.tag!='' ||list.notion!='' ">
							<span v-for="item in list.taglist" class="tagspan">{{item}}</span>  
							<span v-for="item in list.notionlist">{{item}}</span>  
						</p>
					</div>
				</li> 
			</ul>
			</div>
		</div>
		<div class="index_block">
			<div class="centerpage whitebox">
			<div class="block_title oh">
				<h3 class="title fl">创新资源</h3>
				<span @click="routerTo('innovativeResources',{})" class="a-router fr">查看更多>></span>
			</div>
			<ul class="index_leaderc_list">
				 <li v-for="(list,index) in academylist" @click="enterpriserouter('/resources-enterprises',4,list.id)"  >
				 	<div class="mibox"> 
				 		<div class="mi-title oh">
				 			<span class="title fl">{{list.title}}</span> 
				 		</div>
				 		<p class="companyinfor ">
				 			<span><i>注册资本：</i><em>{{list.regCapital}}</em></span>
				 			<span><i>地区：</i><em>{{list.area}}</em></span>
				 		</p>
				 		<p class="companyinfor">
				 			<span class="fl"><i>所属行业：</i><em>{{list.industry}}</em> </span>
				 			<span class="fl"><i>成立日期：</i><em>{{list.createTime}}</em> </span>
				 		</p> 
				 		<p class="conpanytags" v-if="list.tag!=''">
				 			<span v-for="item in list.taglist" class="tagspan">{{item}}</span>  
				 		</p>
				 	</div>
				 </li>
			</ul>
		</div>
		</div> 
		<div class="index_block">
			<div class="centerpage whitebox">
			<div class="block_title oh">
				<h3 class="title fl">投资机构</h3>
				<span @click="routerTo('investmentInstitutions',{})" class="a-router fr">查看更多>></span>
			</div>
			<ul class="index_leaderc_list">
				<li v-for="list in investorglist" @click="enterpriserouter('/investement-enterprises',5,list.id)" >
					<div class="mibox"> 
						<div class="mi-title oh">
							<span class="title fl">{{list.name}}</span>
						</div>
						<p class="companyinfor ">
							<span class="fl"><i>机构类型：</i><em>{{list.type}}</em> </span> 
						</p>
						<p class="companyinfor">
							<span class="fl"><i>投资阶段：</i><em>{{list.stage}}</em> </span>
							<span class="fl"><i>成立时间：</i><em>{{list.createTime}}</em> </span>
						</p>
						<p class="companyinfor">
						<span class="fl"><i>管理规模：</i><em>{{list.asset}}</em> </span> 
						<span class="fl"><i>项目数：</i><em>{{list.projectCount}}</em></span>
						</p>
						<p class="companyinfor onelines" v-show="list.summary!=''"><span><i>机构简介：</i><em>{{list.summary}}</em></span></p>
						<p class="conpanytags" v-if="list.tag !=''">
							 <span v-for="item in list.taglist"class="tagspan">{{item}}</span>  
						</p>
					</div>
				</li> 
			</ul>
		</div></div>
		<div class="index_block"  >
			<div class="centerpage whitebox">
			<div class="block_title oh">
				<h3 class="title fl">行业基本数据</h3>
				<div class="fl">
					<span class="current">热点推荐</span>
					<router-link to="/" class="a-router">企业库</router-link>
					<router-link to="/" class="a-router">投资库</router-link>
					<router-link to="/" class="a-router">土地库</router-link>
					<router-link to="/" class="a-router">宏观库</router-link>
				</div>
			</div>
			<div id="index-base-data">
				<div class="index-echart">
					<div class="index-echart-box " id="investmenttrend"></div>
					<div class="echart-title">
						<h4 class="title">投资趋势</h4>
						<p class="smfont">
							<span>投资项目 | 33592</span>
							<span>投资金额 | 189347</span>
							<span>融资项目 | 3896</span>
							<span>并购项目 | 3514</span>
						</p>
					</div>
				</div>
				<div class="index-echart">
					<div class="index-echart-box " id="landtrend"></div>
					<div class="echart-title">
						<h4 class="title">拿地趋势</h4>
						<p class="smfont">
							<span>成交走势查询</span>
							<span>城市对比</span>
							<span>区域对比</span>
						</p>
					</div>
				</div>
			</div>
			</div>
		</div>
		<footerbar></footerbar>
	</div>
</template>
<script>
	export default {
		name: 'index',
		data() {
			return {
				title: "首页",
				islogin: false,
				userdata:{},
				hotchainlist: [],
				leadingenlist:[	],
				innovativeenlist:[],
				academylist:[],
				investorglist:[],
				public_tooltip: {
					trigger: 'axis',
					backgroundColor: 'rgba(255,255,255,0.9)',
					borderColor: '#ddd',
					borderWidth: '1',
					textStyle: {
						color: '#000',
						fontSize: 14,
					}
				},
				colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#3975b8"],
				investmenttrend: {
					unit: ["亿", "个"],
					name: ["投资金额（亿元)", "投资数量"],
					yline1: [2406.1682, 4628.1412, 8414.2505, 3381.8713, 9474.3809, 2865.3261, 3504.6215, 6279.3805,
						3523.8836, 2764.9843, 2364.6451, 2486.4395, 955.184
					],
					yline2: [2406.1682, 4628.1412, 8414.2505, 3381.8713, 9474.3809, 2865.3261, 3504.6215, 6279.3805,
						3523.8836, 2764.9843, 2364.6451, 2486.4395, 955.184
					],
					xline: ["2020年5月", "2020年6月", "2020年7月", "2020年8月", "2020年9月", "2020年10月", "2020年11月", "2020年12月",
						"2021年1月", "2021年2月", "2021年3月", "2021年4月", "2021年5月"
					]
				},
				landtrend: {
					unit: ["亩", "个"],
					name: ["成交面积", "成交数量"],
					yline1: [172550, 238256, 273250, 286014, 203530, 189601, 209763, 265727, 439435, 278955, 158263,
						250213, 104722
					],
					yline2: [3966, 5380, 5802, 5827, 4838, 5124, 4596, 6078, 8092, 5752, 3198, 5297, 2435],
					xline: ["2020-04", "2020-05", "2020-06", "2020-07", "2020-08", "2020-09", "2020-10", "2020-11",
						"2020-12", "2021-01", "2021-02", "2021-03", "2021-04"
					]
				},
				
			}
		},
		created() {
			var _this=this;
			// console.log(typeof(this.$store.state.userData)) 
			if(this.common.userdata.length > 0){
				this.userdata=JSON.parse(this.common.userdata)
			}else{
				this.userdata=this.getuseriformation();
			} 
			this.getindexvalue(); 
		},
		mounted() {
			// this.userdata = this.getuseriformation();
			// this.islogin = this.userdata != null;
			this.twoDataEchart('investmenttrend', this.investmenttrend);
			this.twoDataEchart('landtrend', this.landtrend);
	 
		},
		methods: {
			getindexvalue(){
				var _this=this;
				console.log(1);
				_this.bus.$emit('loading', true);
				// console.log(this.userdata, this.common.userdata.length);
				this.$axios.get(this.$api.cyl.home.all(),{headers:{AuthToken:this.userdata.token}}).then(function(res){ 
					if(res.data.success){   
						// console.log(res.data.data)
						let datar=res.data.data; 
						_this.hotchainlist=datar.chain; 
						_this.leadingenlist=_this.taglist(datar.leadingEnterprise);  
						_this.innovativeenlist=_this.taglist(datar.innovativeEnterprise);
						 _this.academylist=_this.taglist(datar.academy); 
							 _this.investorglist=_this.taglist(datar.investOrg);  
								_this.bus.$emit('loading', false);
								console.log(datar)
					}else{ 
							
					} 
				}).catch(function (error) { 
					// 请求失败处理 console.log(error);
				});  
			}, 
			enterpriserouter(path, type, id) { 
				this.routerlinkarry(path,{type:type,id:id});
			},
			chainrouter(name,id){ 
				this.routerlinkarry(name,{chainid:id});
			},
			taglist(arry){
				for(var i=0;i<arry.length;i++){ 
					if(arry[i].tag != undefined && arry[i].tag == ""){
						arry[i].taglist=[];
					}else if(arry[i].tag != undefined && arry[i].tag != ""){
						let tagstring=arry[i].tag;
						arry[i].taglist=tagstring.split(',');
					} 
					if(arry[i].notion != undefined && arry[i].notion == ""){
						arry[i].notionlist=[];
					}else if(arry[i].notion != undefined && arry[i].notion != ""){
						let notionstring=arry[i].notion;
						arry[i].notionlist=notionstring.split(',');
					}
				} 
				// console.log('taglist',arry);
				return arry; 
			},
			twoDataEchart($el, datas) {
				//	initCalendar(); 
				//if($el.length<0)return;
				var chart = echarts.init(document.getElementById($el));
				var _this = this;
				var options3 = {
					tooltip: _this.public_tooltip,
					color: _this.colors,
					legend: {
						data: datas.name,
						top: 20,
						left: "center",
					},
					grid: {
						x: 80, 	y: 50, x2: 80, y2: 30,
						show: true, backgroundColor: "#f8fbfe", 	borderWidth: 0,
					},
					xAxis: {
						type: 'category',
						data: datas.xline,
						axisLine: {
							lineStyle: {
								color: "#aaa",
								width: 1
							}
						},
						nameTextStyle: {
							fontSize: 12
						},
					},
					yAxis: [{
							type: 'value',
							splitLine: {
								show: false
							},
							axisLine: {
								lineStyle: {
									color: "#aaa",
									width: 1
								}
							},
							splitLine: {
								lineStyle: {
									color: ["#eee"],
									width: 1
								}
							},
							fontsize: 12,
							name: datas.unit[0],
							axisLabel: {
								formatter: '{value}',
							}
						},
						{
							type: 'value',
							axisLine: {
								lineStyle: {
									color: "#aaa",
									width: 1
								}
							},
							splitLine: {
								lineStyle: {
									color: ["#eee"],
									width: 1
								}
							},
							name: datas.unit[1],
							axisLabel: {
								formatter: '{value}',
							}
						}
					],
					series: [{
							name: datas.name[0],
							type: 'bar',
							//					barGap:10,
							barWidth: 20,
							//barCategoryGap: 50, 
							data: datas.yline1
						},
						{
							name: datas.name[1],
							type: 'line',
							barWidth: 30,
							symbol: 'circle',
							symbolSize: 10,
							yAxisIndex: 1,
							data: datas.yline2,
						},
					]
				};
				// formaterfun(options3, datas.unit);
				// hasDataZoom(options3, datas.xline)
				chart.setOption(options3);
			},

		}
	}
</script>

<style>


</style>
